import cookie from 'js-cookie'
import axios from 'axios'
import {api} from './api'
import * as HttpStatus from 'http-status-codes';

export default {
    login(username, password, callback) {
        let portal = process.env.VUE_APP_PORTAL

        axios.post(portal + '/api/employee/auth', {
            username,
            password
        })
            .then(({data}) => {
                cookie.set('token', data.data.token, {expires: 7});
                callback(true, false)
            })
            .catch(({response}) => {
                if (response.status === HttpStatus.UNAUTHORIZED || response.status === HttpStatus.LOCKED) {
                    callback(false, {username: [response.data.message]});
                }
                callback(false, response.data.errors)
            })
    },

    loginWithToken(token, callback) {
        cookie.set('token', token, {expires: 7});
        callback(true, false);
    },

    checkToken(callback) {
        api().get('verify')
            .then(({data}) => {
                callback(true, false)
            })
            .catch(({response}) => {
                this.logout()
                callback(false, true)
            })
    },

    loggedIn() {
        return !!cookie.get('token')
    },

    logout() {
        cookie.remove('token')
        return true
    },

    getToken() {
        return cookie.get('token')
    },

    onChange() {
    },

    requestResetPassword(email, callback) {
        api()
            .post('password', {email})
            .then(({data}) => {
                callback(true, false);
            })
            .catch(({response}) => {
                callback(false, response.data.errors);
            });
    },

    requestLoginIssue(email, issue, callback) {
        api()
            .post('auth/issue', {
                email,
                issue,
            })
            .then(({data}) => {
                callback(true, false);
            })
            .catch(({response}) => {
                callback(false, response.data.errors);
            });
    },
}
